import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipsis'
})
export class EllipsisPipe implements PipeTransform {

  transform(value: string, limit = 50): any {
    if (value?.length > limit) {
      return value.substring(0, limit) + '...';
    }
    return value;
  }

}
